// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"470":"navbar","845":"profile"}[chunkId] || chunkId) + "." + {"329":"52f6d9e3","366":"7243cc78","470":"53d5fbf5","596":"6d32fd1f","787":"425f66d6","845":"2d730491"}[chunkId] + ".chunk.js";
};